<template>
  <v-container fluid class="container-page">
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="12"
        class="d-flex v-middle text-title-container justify-space-between"
      >
        <div class="d-flex">
          <div class="text-title text-primary">Realtime</div>
          <span class="m-l-20 datetime">
            Today : {{ datetime | datetimeFormatWithSeconds }}
          </span>
        </div>
        <div class="d-flex v-middle">
          <v-combobox
            v-model="channelSelected"
            :items="channels"
            item-value="value"
            item-text="label"
            hide-selected
            label="Channel"
            dense
            hide-details
            class="width200px"
          >
            <template v-slot:selection="{ attrs, item }">
              <div class="d-flex align-center">
                <v-icon v-if="item.icon" :class="item.class" class="m-r-5">
                  {{ item.icon }}
                </v-icon>
                <v-avatar v-if="item.img" size="20" class="m-r-5">
                  <img :src="item.img" :alt="item.label" />
                </v-avatar>
                {{ item.label ? item.label : channelSelected }}
              </div>
            </template>
            <template v-slot:item="{ index, item }">
              <v-list-item-content class="list-icon">
                <div class="d-flex align-center">
                  <v-icon v-if="item.icon" :class="item.class" class="m-r-5">
                    {{ item.icon }}
                  </v-icon>
                  <v-avatar v-if="item.img" size="22" class="m-r-5">
                    <img :src="item.img" :alt="item.label" />
                  </v-avatar>
                  {{ item.label }}
                </div>
              </v-list-item-content>
            </template>
          </v-combobox>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        v-for="(obj, key) in components"
        :cols="obj.cols"
        :sm="obj.sm"
        :lg="obj.lg"
        :key="key"
      >
        <component
          :index="key"
          :title="obj.title"
          :is="componentStore[obj.component]"
          :refresh="refresh[key].value"
          :from="from"
          :to="to"
          :type="obj.type"
          :direction="obj.direction"
          :channel="channel"
          :icon="obj.icon"
          @viewConver="viewConver"
          @clearLoading="clearLoading"
        />
      </v-col>
    </v-row>

    <!-- <v-row>
      <v-col
        v-if="
          (viewVoice() || viewAll()) && (viewInbound() || viewDirectionAll())
        "
        sm="12"
        :lg="viewOutbound() || viewDirectionAll() ? 6 : 12"
        class="text-title-container"
      >
        <v-card outlined :elevation="5">
          <v-row>
            <v-col>
              <v-card
                class="no-shadow"
                @click="
                  viewConver({
                    from,
                    to,
                    direction: directionInbound,
                    type: 'voice'
                  })
                "
              >
                <widget-voice-session
                  :refresh="trigger.voiceSession"
                  :direction="directionInbound"
                  @reset="resetTrigger"
                />
              </v-card>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col>
              <v-card
                class="no-shadow"
                @click="
                  viewConver({
                    from,
                    to,
                    direction: directionInbound,
                    type: 'voice',
                    group: 'session-success'
                  })
                "
              >
                <widget-voice-session-success
                  :refresh="trigger.voiceSessionSuccess"
                  :direction="directionInbound"
                  @reset="resetTrigger"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col
        v-if="
          (viewVoice() || viewAll()) && (viewOutbound() || viewDirectionAll())
        "
        sm="12"
        :lg="viewInbound() || viewDirectionAll() ? 6 : 12"
        class="text-title-container"
      >
        <v-card outlined :elevation="5">
          <v-row>
            <v-col>
              <v-card
                v-if="noCampaign"
                class="no-shadow"
                @click="
                  viewConver({
                    from,
                    to,
                    direction: directionOutbound,
                    type: 'voice'
                  })
                "
              >
                <widget-voice-session
                  :refresh="trigger.voiceSession"
                  :direction="directionOutbound"
                  @reset="resetTrigger"
                />
              </v-card>
              <v-card v-else class="no-shadow">
                <widget-voice-call
                  :refresh="trigger.voiceCall"
                  @reset="resetTrigger"
                />
              </v-card>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col>
              <v-card
                v-if="noCampaign"
                class="no-shadow"
                @click="
                  viewConver({
                    from,
                    to,
                    direction: directionOutbound,
                    type: 'voice',
                    group: 'session-success'
                  })
                "
              >
                <widget-voice-session-success
                  :refresh="trigger.voiceSessionSuccess"
                  :direction="directionOutbound"
                  @reset="resetTrigger"
                />
              </v-card>
              <v-card
                v-else
                class="no-shadow"
                @click="
                  viewConver({
                    from,
                    to,
                    direction: directionOutbound,
                    type: 'voice'
                  })
                "
              >
                <widget-voice-answered-call
                  :refresh="trigger.voiceAnsweredCall"
                  @reset="resetTrigger"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col v-if="viewChat() || viewAll()" sm="12" lg="12">
        <v-card outlined :elevation="5">
          <v-row>
            <v-col>
              <v-card
                class="no-shadow"
                @click="viewConver({ from, to, direction, type: 'chat' })"
              >
                <widget-chat-session
                  :refresh="trigger.chatSession"
                  :direction="directionInbound"
                  @reset="resetTrigger"
                />
              </v-card>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col>
              <v-card
                class="no-shadow"
                @click="
                  viewConver({
                    from,
                    to,
                    directionInbound,
                    type: 'chat',
                    group: 'session-success'
                  })
                "
              >
                <widget-chat-session-success
                  :refresh="trigger.chatSessionSuccess"
                  :direction="directionInbound"
                  @reset="resetTrigger"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="8">
        <time-serie-active
          :class="
            viewVoice() || viewChat() ? 'dynamic-height' : 'dynamic-height1'
          "
          :refresh="trigger.timeSerieActive"
          :view-type="viewType"
          :direction="directionInbound"
          @reset="resetTrigger"
        />
      </v-col>
      <v-col cols="4">
        <tag-cloud-table
          v-if="tagCloudType === 'table'"
          :class="
            viewVoice() || viewChat() ? 'dynamic-height' : 'dynamic-height1'
          "
          :refresh="trigger.tagCloud"
          @reset="resetTrigger"
        />
        <tag-cloud
          v-else
          :class="
            viewVoice() || viewChat() ? 'dynamic-height' : 'dynamic-height1'
          "
          :refresh="trigger.tagCloud"
          @reset="resetTrigger"
        />
      </v-col>
    </v-row> -->
  </v-container>
</template>

<script>
import Moment from 'moment'
import _ from 'lodash'

import Vue from 'vue'
import vueSocketIO from 'vue-socket.io'

import apiDashboard from '@/apis/dashboard'
import apiReport from '@/apis/report'

import Facebook from '@/assets/facebook.png'
import Line from '@/assets/line.png'

import Components from '@/components/dashboard/index'

Vue.use(
  new vueSocketIO({
    debug: process.env.VUE_APP_DEBUG_SOCKET_BACKEND_CONNECTION == 'true',
    connection: process.env.VUE_APP_CORE_BACKEND
  })
)

export default {
  name: 'Realtime',
  data() {
    return {
      viewDirection: process.env.VUE_APP_DIRECTION,
      viewType: process.env.VUE_APP_TYPE,
      tagCloudType: process.env.VUE_APP_TAG_CLOUD_TYPE,
      interval: null,
      datetime: new Date(),
      format: 'YYYY-MM-DD HH:mm',
      channel: 'all',
      from: '',
      to: '',
      intervalTagCloud: 60,
      lastTagcloud: {},
      trigger: [],
      refresh: [],
      componentStore: Components,
      components: [],
      channelSelected: '(All)',
      channels: [{ value: 'all', label: '(All)' }],
      noCampaign: process.env.VUE_APP_NO_CAMPAIGN === 'true'
    }
  },
  mounted() {},
  async created() {
    document.title = this.$t('page-title.realtime', {
      productName: this.$options.filters.getVariable('product_name')
    })

    this.from = Moment()
      .startOf('day')
      .format(this.format)
    this.to = Moment()
      .add(1, 'days')
      .startOf('day')
      .format(this.format)

    await this.initial()
  },
  watch: {
    channelSelected: {
      handler() {
        if (this.channelSelected) {
          if (this.channelSelected === '(All)') this.channel = 'all'
          else if (typeof this.channelSelected === 'string')
            this.channel = this.channelSelected
          else {
            const obj = _.find(this.channels, {
              label: this.channelSelected.value
            })
            this.channel = obj ? obj.value : this.channelSelected.value
          }
        }

        clearInterval(this.interval)
        for (let i = 0; i < this.components.length; i++) {
          const obj = this.components[i]
          this.trigger[i].value = true
          this.refresh[i].value += 1

          if (['tag_cloud', 'tag_cloud_table'].includes(obj.component)) {
            this.lastTagcloud[obj.component] = Moment()
          }
        }

        this.setTimeInterval()
      }
    }
  },
  destroyed() {
    clearInterval(this.interval)
  },
  sockets: {
    connect: function() {},
    trigger: async function(data) {
      if (data && data.channel)
        for (let i = 0; i < this.components.length; i++) {
          const obj = this.components[i]
          if (
            !['tag_cloud', 'tag_cloud_table'].includes(obj.component) &&
            (obj.type === data.channel || obj.type === 'all')
          ) {
            if (!this.trigger[i].value) {
              this.trigger[i].value = true
              this.refresh[i].value += 1
            }
          }
        }
    }
  },
  methods: {
    async initial() {
      await this.getChannel()
      await this.getInitialDashboard()
      this.setTimeInterval()
    },
    async getChannel() {
      try {
        const getChannel = await apiReport.getListChannel('all')
        const { data } = getChannel

        this.channels = [{ value: 'all', label: '(All)' }]

        for (const obj of data) {
          const list = {}

          list.value = obj._id
          list.label = obj.channel
          list.img = obj.img

          if (obj.platform === 'facebook') list.img = Facebook
          if (obj.platform === 'line') list.img = Line
          if (obj.platform === 'phone') {
            list.icon = 'mdi-phone-incoming'
            list.class = 'icon-voice-inbound'
          }

          this.channels.push(list)
        }
      } catch (error) {}
    },
    async getInitialDashboard() {
      try {
        const getInitialDashboard = await apiDashboard.getInitialDashboard(
          'realtime'
        )

        this.components = await getInitialDashboard.components

        for (const obj of this.components) {
          this.trigger.push({ value: true })
          this.refresh.push({ value: 1 })

          if (['tag_cloud', 'tag_cloud_table'].includes(obj.component)) {
            this.lastTagcloud[obj.component] = Moment()
          }
        }
      } catch (error) {}
    },
    setTimeInterval() {
      const findTagCloud = _.filter(this.components, o => {
        return ['tag_cloud', 'tag_cloud_table'].includes(o.component)
      })

      if (findTagCloud) {
        this.interval = setInterval(() => {
          this.datetime = Moment()
          const sec = this.datetime.format('ss')
          const isTrig = sec % this.intervalTagCloud === 0

          for (let i = 0; i < findTagCloud.length; i++) {
            const obj = findTagCloud[i]

            const indexTagCloud = _.findIndex(this.components, {
              component: obj.component
            })
            if (indexTagCloud > -1) {
              if (
                isTrig &&
                !this.trigger[indexTagCloud].value &&
                Moment(this.datetime).diff(
                  Moment(this.lastTagcloud[obj.component]),
                  'seconds'
                ) >= 5
              ) {
                this.lastTagcloud[obj.component] = this.datetime
                this.refresh[indexTagCloud].value += 1
              }
            }
          }
        }, 1000)
      }
    },
    viewConver(query) {
      let routeData = this.$router.resolve({
        path: '/conversations',
        query
      })
      window.open(routeData.href, '_blank')
    },
    clearLoading(index) {
      this.trigger[index].value = false
    }
  }
}
</script>

<style lang="scss" scoped>
.datetime {
  color: #222222;
  margin-top: 14px;
}

.dynamic-height {
  height: calc(100vh - 299px);
}

.dynamic-height1 {
  height: calc(100vh - 465px);
}

.no-shadow {
  box-shadow: none !important;
}

.width200px {
  width: 200px;
  min-width: 200px;
  max-width: 200px;
}
</style>
